module.exports = __webpack_public_path__ + "static/media/logo.bb55cca2.png";